import ArticleLayout from '@/components/feature/ArticleLayout';
import { sugargooCoupon } from '@/utils/articleContent';

export default function SugargooCouponPage() {
  return <ArticleLayout article={sugargooCoupon} />;
}